import React, {PureComponent} from 'react';
import CommonFields from './CommonFields';

class Geo1Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
            </>
        );
    }
}

export default Geo1Type;
